/* ===================================================================
   App — bootstrap wrapper. Loads persisted state from the API and the
   firm's default τ thresholds from the Senior Associate service, then
   mounts <AppShell> with the resolved initial state. Renders a tiny
   loader while either fetch is in flight.
=================================================================== */
import React, { useEffect, useState } from "react";
import { fetchBootstrap } from "./api/client";
import { saGet } from "./sa";
import { buildInitial } from "./state";
import { AppShell } from "./components/Layout/AppShell";
import type { InitialState } from "./types";

type InitWithFirm = InitialState & { firmThresholds?: Record<string, number> | null };

export default function App(): JSX.Element {
  const [initial, setInitial] = useState<InitWithFirm | null>(null);
  useEffect(() => {
    let alive = true;
    // Load persisted app state (:8200) and the firm's default τ thresholds
    // (Senior Associate service config, :8100/config/default_thresholds) together.
    Promise.all([fetchBootstrap(), saGet("/config")]).then(([s, cfg]) => {
      if (!alive) return;
      const init = buildInitial(s) as InitWithFirm;
      const ft = cfg && (cfg as Record<string, unknown>).default_thresholds;
      init.firmThresholds = ft && typeof ft === "object" ? (ft as Record<string, number>) : null;
      setInitial(init);
    });
    return () => {
      alive = false;
    };
  }, []);
  if (!initial)
    return (
      <div className="ass">
        <div
          style={{
            flex: 1,
            display: "grid",
            placeItems: "center",
            color: "var(--tert)",
            fontSize: 13,
          }}
        >
          Loading workspace…
        </div>
      </div>
    );
  return <AppShell initial={initial} />;
}
